import React from 'react';
import { Alert } from 'antd';
import LoadingIndicator from '../components/shared/LoadingIndicator/LoadingIndicator';
import { useNavigate } from "react-router-dom";
import { useFetchTrackedKeywordsCountQuery } from './service';
import useGetSubscription from '../sales/hooks/useGetSubscription';
import useGetPlanSettings from '../sales/hooks/useGetPlanSettings';

export default function TrackedKeywordsCount() {
    const navigate = useNavigate();

    const { userSubscription } = useGetSubscription();
    const { maxKeywords } = useGetPlanSettings();
    const { data: trackedKeywordsCount, isLoading: isLoadingTrackedKeywordsCount } = useFetchTrackedKeywordsCountQuery();

    const handleUpgradePlanClicked = () => {
        navigate('/subscription/plans');
    };

    const isLoading = isLoadingTrackedKeywordsCount || !maxKeywords;
    const showUpgradeText = !!userSubscription && !userSubscription.plan_code.includes('professional');

    return (
        <>
            {isLoading && <LoadingIndicator />}

            {!isLoading && trackedKeywordsCount && (
                <div className="tracked-keywords-count">
                    <Alert
                        message={
                            <p style={{ marginTop: '1em' }}>
                                You are using {trackedKeywordsCount.keywords_no} out of {maxKeywords} maximum keywords limit for all your websites.
                                {showUpgradeText && (
                                    <>
                                        {' '}
                                        If you need more keywords, please consider to:{' '}
                                        <strong>
                                            <span
                                                className="fake-link"
                                                onClick={handleUpgradePlanClicked}
                                            >
                                                Upgrade your plan
                                            </span>
                                        </strong>
                                    </>
                                )}
                            </p>
                        }
                    />
                </div>
            )}
        </>
    );
}
